import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getTargetGroupsIds } from '../../compliance-policies/Windows10CompliancePolicy';
import { assignmentsTargetGroups } from '../../intune-utlity';
import { readLapsSettingsFromSchema } from './helper';
import { DeviceConfigurationWindowsLAPSSchema } from './model';

export function initForm(schema: DeviceConfigurationWindowsLAPSSchema, fb: FormBuilder): FormGroup {
    const settings = readLapsSettingsFromSchema(schema.contains.properties.settings);
    const targets = schema.contains.properties?.assignments?.items?.properties?.target?.oneOf;

    return fb.group({
        policy: fb.group({
            name: [schema.contains.properties.name.const],
            description: [schema.contains.properties.description.const],
            platform: [schema.contains.properties.platform.const],
            technologies: [schema.contains.properties.technologies.const],
        }),

        settings: fb.group({
            backupDirectory: [settings.backupDirectory],
            configurePasswordAge: [settings.configurePasswordAge],
            passwordAgeDays: [settings.passwordAgeDays],
            configurePasswordLength: [settings.configurePasswordLength],
            passwordLength: [
                settings.passwordLength,
                [Validators.required, Validators.min(8), Validators.max(64), Validators.pattern(/^[0-9]+$/)],
            ],
            passwordComplexity: [settings.passwordComplexity],
            administratorAccountName: [settings.administratorAccountName],
            postAuthenticationActions: [settings.postAuthenticationActions],
            configurePostAuthenticationResetDelay: [settings.configurePostAuthenticationResetDelay],
            postAuthenticationResetDelay: [settings.postAuthenticationResetDelay],
            automaticAccountManagementEnabled: [settings.automaticAccountManagementEnabled],
            automaticAccountManagementTarget: [settings.automaticAccountManagementTarget],
            automaticAccountManagementRandomizeName: [settings.automaticAccountManagementRandomizeName],
            automaticAccountManagementEnableAccount: [settings.automaticAccountManagementEnableAccount],
            automaticAccountManagementNameOrPrefix: [settings.automaticAccountManagementNameOrPrefix],
            passwordExpirationProtectionEnabled: [settings.passwordExpirationProtectionEnabled],
            adPasswordEncryptionEnabled: [settings.adPasswordEncryptionEnabled],
            adPasswordEncryptionPrincipal: [settings.adPasswordEncryptionPrincipal],
            configureAdEncryptedPasswordHistorySize: [settings.configureAdEncryptedPasswordHistorySize],
            adEncryptedPasswordHistorySize: [settings.adEncryptedPasswordHistorySize],
        }),

        assignments: fb.group({
            allUsers: [
                targets?.some((res) => res?.properties?.['@odata.type']?.const === assignmentsTargetGroups.allUsers),
            ],
            allDevices: [
                targets?.some((res) => res?.properties?.['@odata.type']?.const === assignmentsTargetGroups.allDevices),
            ],
            includedGroups: [getTargetGroupsIds(schema, assignmentsTargetGroups.groupInclusion)],
            groupInclusion: [
                targets?.some(
                    (res) => res?.properties?.['@odata.type']?.const === assignmentsTargetGroups.groupInclusion,
                ),
            ],
        }),
    });
}
